import { TitleCard } from '@anm/components/PreviewTitleCard';
import { TooltipContent } from '@anm/components/Tooltip';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

const VideoBlockWrapper = styled.div`
  ${TitleCard} {
    ${flexCenter};
    min-height: 54px;
    border-top: 1px solid rgba(1, 83, 130, 0.2);
  }
  ${TooltipContent} {
    max-width: 213px;
    transform: translate(0, calc(-100% - 12px));
    &::before {
      right: 16px;
      border-width: 0 9px 10px 9px;
    }
    p {
      margin: 0;
      color: white;
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

export const VideoBlockTooltipLink = styled.a`
  display: block;
`;

export const DurationBadge = styled.div`
  color: #fff;
  right: 10px;
  bottom: 10px;
  height: 27px;
  z-index: 151;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  border-radius: 5px;
  min-width: inherit;
  padding-left: 10px;
  position: absolute;
  padding-right: 10px;
  display: inline-flex;
  background-color: rgba(41, 42, 43, 0.6);
`;

export default VideoBlockWrapper;
